import { Box, Skeleton, Stack } from "@mui/material";

function ShiftHistoryListItemSkeleton() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingY: theme.spacing(5),
        borderBottom: `1px solid ${theme.palette.border?.subtle}`,
        backgroundColor: theme.palette.background.tertiary,
      })}
      role="progressbar"
      aria-label="Loading shift history"
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="30%" height="0.875rem" />
          <Skeleton variant="text" width="55%" height="1rem" />
          <Skeleton variant="text" width="45%" height="0.875rem" />
        </Stack>

        <Stack alignItems="flex-end" justifyContent="center" sx={{ flexShrink: 0 }}>
          <Skeleton variant="text" width={60} height="1rem" />
        </Stack>
      </Stack>
    </Box>
  );
}

export function ShiftHistoryLoadingPageState() {
  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={6} sx={{ paddingBottom: 2 }}>
        <Skeleton variant="text" width={120} height="1.75rem" />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
      {Array.from({ length: 5 }, (_, index) => (
        <ShiftHistoryListItemSkeleton key={index} />
      ))}
    </Stack>
  );
}
